
// -- -- -- -- -- -- -- -- -- -- --
// Init the Slide Function

document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const navCollapse = document.getElementById('navbarToggleExternalContent');
  const toggler = document.querySelector('.navbar-toggler');

  if (!navCollapse || !toggler) return;

  const setState = () => {
	body.classList.toggle('nav-open', navCollapse.classList.contains('show'));
  };

  // Initialzustand
  setState();

  // Bootstrap Events (zuverlässig)
  navCollapse.addEventListener('shown.bs.collapse', setState);
  navCollapse.addEventListener('hidden.bs.collapse', setState);

  // Fallback, falls Bootstrap Events nicht feuern
  toggler.addEventListener('click', () => setTimeout(setState, 0));
});

$( document ).ready(function() { 
	setTimeout(function() {
		$('#navbarToggleExternalContent .menu-item a').on( "click", function() {
			new bootstrap.Collapse(document.getElementById("navbarToggleExternalContent")).hide();
		});
	}, 610);
	
	$('.block_gaveg-accordion .accordion-item').on( "click", function() {
		setTimeout(function() {
			if(!$('.block_gaveg-accordion .accordion-item form button.btn.btn-block.btn-primary svg').length){
				var svgIcon = '<svg fill="none" height="15" viewBox="0 0 19 15" width="19" xmlns="http://www.w3.org/2000/svg"><path d="m18.7071 8.07088c.3905-.39053.3905-1.02369 0-1.41422l-6.364-6.363958c-.3905-.3905247-1.0236-.3905247-1.4142 0-.3905.390524-.3905 1.023688 0 1.414218l5.6569 5.65685-5.6569 5.65683c-.3905.3905-.3905 1.0237 0 1.4142.3906.3906 1.0237.3906 1.4142 0zm-18.7071-.70711v1h18v-1-1h-18z" fill="#00427f"/></svg>';
				$('.block_gaveg-accordion .accordion-item form button.btn.btn-block.btn-primary').append(svgIcon);
			}
		}, 610);
	});
	
	setTimeout(function() {
		if ($('#ws-form-1 #wsf-1-field-15').length) {
			var svgIcon = '<svg fill="none" height="15" viewBox="0 0 19 15" width="19" xmlns="http://www.w3.org/2000/svg"><path d="m18.7071 8.07088c.3905-.39053.3905-1.02369 0-1.41422l-6.364-6.363958c-.3905-.3905247-1.0236-.3905247-1.4142 0-.3905.390524-.3905 1.023688 0 1.414218l5.6569 5.65685-5.6569 5.65683c-.3905.3905-.3905 1.0237 0 1.4142.3906.3906 1.0237.3906 1.4142 0zm-18.7071-.70711v1h18v-1-1h-18z" fill="#ffffff"/></svg>';
			$('#ws-form-1 #wsf-1-field-15').append(svgIcon);
		}
		if ($('#ws-form-1 #wsf-1-field-32').length) {
			var svgIcon = '<svg fill="none" height="15" viewBox="0 0 19 15" width="19" xmlns="http://www.w3.org/2000/svg"><path d="m18.7071 8.07088c.3905-.39053.3905-1.02369 0-1.41422l-6.364-6.363958c-.3905-.3905247-1.0236-.3905247-1.4142 0-.3905.390524-.3905 1.023688 0 1.414218l5.6569 5.65685-5.6569 5.65683c-.3905.3905-.3905 1.0237 0 1.4142.3906.3906 1.0237.3906 1.4142 0zm-18.7071-.70711v1h18v-1-1h-18z" fill="#00427f"/></svg>';
			$('#ws-form-1 #wsf-1-field-32').append(svgIcon);
		}
		if ($('#ws-form-1 #wsf-1-field-46').length) {
			var svgIcon = '<svg fill="none" height="15" viewBox="0 0 19 15" width="19" xmlns="http://www.w3.org/2000/svg"><path d="m18.7071 8.07088c.3905-.39053.3905-1.02369 0-1.41422l-6.364-6.363958c-.3905-.3905247-1.0236-.3905247-1.4142 0-.3905.390524-.3905 1.023688 0 1.414218l5.6569 5.65685-5.6569 5.65683c-.3905.3905-.3905 1.0237 0 1.4142.3906.3906 1.0237.3906 1.4142 0zm-18.7071-.70711v1h18v-1-1h-18z" fill="#00427f"/></svg>';
			$('#ws-form-1 #wsf-1-field-46').append(svgIcon);
		}
		if ($('#ws-form-1 #wsf-1-field-80').length) {
			var svgIcon = '<svg fill="none" height="15" viewBox="0 0 19 15" width="19" xmlns="http://www.w3.org/2000/svg"><path d="m18.7071 8.07088c.3905-.39053.3905-1.02369 0-1.41422l-6.364-6.363958c-.3905-.3905247-1.0236-.3905247-1.4142 0-.3905.390524-.3905 1.023688 0 1.414218l5.6569 5.65685-5.6569 5.65683c-.3905.3905-.3905 1.0237 0 1.4142.3906.3906 1.0237.3906 1.4142 0zm-18.7071-.70711v1h18v-1-1h-18z" fill="#ffffff"/></svg>';
			$('#ws-form-1 #wsf-1-field-80').append(svgIcon);
		}
	}, 500);
	
	$(window).scroll(function() {    
		var scroll = $(window).scrollTop();
		if (scroll >= 50) {
			$("header").addClass("active");
			$(".pre-header-container").addClass("p-2");
			$("#navbar-brand-container").addClass("py-1");
			$("#navbar-brand-container").removeClass("py-4");
		}else{
			$("header").removeClass("active");
			$(".pre-header-container").removeClass("p-2");
			$("#navbar-brand-container").addClass("py-4");
		}
	});
	
	$('.newsslider').each(function( index ) {
	  $(this).slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			//arrows : false,
			prevArrow: $('#prev-arrow'),
			nextArrow: $('#next-arrow'),
			infinite: true,
			autoplay: false,
			swipeToSlide: false,
			swipe: false,
			autoplaySpeed: 2000,
			responsive: [
				{
				  breakpoint: 600,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				  }
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			  ]
	  });
	});
	if ($(window).width() > 600) {
	   var sWidth = $('.newsslider > div').outerWidth();
	   var cWidth = (sWidth / 3) * 2;
	   var nWidth = sWidth / 3;
	   setTimeout(function() {
		   $('.newsslider > div .slick-current').attr('style', 'width: '+cWidth+'px !important');
		   $('.newsslider > div .slick-current').next().attr('style', 'width: '+nWidth+'px !important'); 
	   }, 1000);
		   $('.newsslider').parent().find('.slider-arrow').on( "click", function() {
			setTimeout(function() {
				$('.newsslider > div .slick-current').attr('style', 'width: '+cWidth+'px !important');
				$('.newsslider > div .slick-current').next().attr('style', 'width: '+nWidth+'px !important');
			}, 610);
		   });
	}
	
	$('.referenzenslider').each(function( index ) {
	  $(this).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots : true,
			arrows : false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 2000,
			responsive: [
				{
				  breakpoint: 650,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				  }
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			  ]
	  });
	});
	
	if ($(window).width() > 800) {
	   var sWidth = $('.referenzenslider > div').outerWidth();
	   //var cWidth = (sWidth / 3) * 2.25;
	   
	   setTimeout(function() {
		   //$('.referenzenslider > div .slick-current').attr('style', 'width: '+cWidth+'px !important');
		   
	   }, 1000);
		   $('.referenzenslider').parent().find('.slider-arrow').on( "click", function() {
			setTimeout(function() {
				$('.referenzenslider > div .slick-current').attr('style', 'width: '+cWidth+'px !important');
				
			}, 610);
		   });
	}

	setTimeout(function(){ 
		var height = $('.newsslider').height();
		$('.newsslider').css('height' , height);
		var height2 = $('.referenzenslider').height();
		$('.referenzenslider').css('height' , height2);
	}, 2000);
	$('.newsslider .slick-track').addClass('d-flex');
	$('.newsslider .slick-list').addClass('overflow-hidden');
	$('.referenzenslider .slick-track').addClass('d-flex');
	$('.referenzenslider .slick-list').addClass('overflow-hidden');
	
	$.fn.isInViewport = function() {
		var elementTop = $(this).offset().top;
		var elementBottom = elementTop + $(this).outerHeight();
	
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
	
		return elementBottom > viewportTop && elementTop < viewportBottom;
	};
	
	var $timelineItem = $('.timeline .timeline-item');
	$(window).on('resize scroll', function() {
		$timelineItem.each(function( index ) {
			if ($(this).isInViewport()) {
				$(this).addClass('active').removeClass('inactive');
			} else {
				$(this).removeClass('active').addClass('inactive');
			}
		});
	});
	
}); 

	(function ($) {
  $(function () {

	(function ($) {
	  $(function () {
	
		$('[data-slider-root]').each(function (i) {
		  const $root  = $(this);
		  const $wrap  = $root.find('[data-slider-wrapper]').first();
		  const $track = $root.find('[data-slider-track]').first();
		  const $prev  = $root.find('.s1-prev').first();
		  const $next  = $root.find('.s1-next').first();
	
		  if (!$wrap.length || !$track.length) return;
	
		  const getGap = () =>
			parseFloat(getComputedStyle($wrap[0]).getPropertyValue('--gap')) || 16;
	
		  function computeVisible() {
			const wrapW = $wrap[0].clientWidth;
			const gap   = getGap();
			const maxItem = 310;
			const theoretical = Math.max(1, Math.floor((wrapW + gap) / (maxItem + gap)));
	
			const w = window.innerWidth;
			const minMobile = 2;
			const minTablet = 4;
			const minRequired = (w >= 768) ? minTablet : minMobile;
	
			let visible = Math.max(minRequired, theoretical);
	
			// Desktop immer exakt 4 Logos
			if (w >= 992) visible = 4;
	
			$wrap[0].style.setProperty('--visible', visible);
			return visible;
		  }
	
		  function getItemPlusGap() {
			const $first = $track.children().first();
			if (!$first.length) return 0;
			const rect = $first[0].getBoundingClientRect();
			return rect.width + getGap();
		  }
	
		  function scrollByItem(dir = 1) {
			const step = getItemPlusGap();
			$track.stop(true).animate(
			  { scrollLeft: $track.scrollLeft() + dir * step },
			  300
			);
		  }
	
		  // ===== AUTOPLAY =====
		  const AUTOPLAY_MS = 2800;
		  let autoplayTimer = null;
		  let isPaused = false;
	
		  function startAutoplay() {
			stopAutoplay();
			autoplayTimer = setInterval(function () {
			  if (isPaused) return;
			  scrollByItem(1);
			}, AUTOPLAY_MS);
		  }
	
		  function stopAutoplay() {
			if (autoplayTimer) {
			  clearInterval(autoplayTimer);
			  autoplayTimer = null;
			}
		  }
	
		  function pauseAutoplay() {
			isPaused = true;
		  }
	
		  function resumeAutoplay() {
			isPaused = false;
		  }
	
		  // Buttons
		  $prev.on('click', function () {
			scrollByItem(-1);
			startAutoplay(); // nach manuellem Klick neu takten
		  });
	
		  $next.on('click', function () {
			scrollByItem(1);
			startAutoplay();
		  });
	
		  // Pause bei Hover/Touch/Fokus
		  $root.on('mouseenter touchstart focusin', pauseAutoplay);
		  $root.on('mouseleave touchend focusout', resumeAutoplay);
	
		  // Pause wenn Tab nicht sichtbar
		  document.addEventListener('visibilitychange', function () {
			if (document.hidden) {
			  pauseAutoplay();
			} else {
			  resumeAutoplay();
			}
		  });
	
		  // Resize
		  let resizeTO;
		  const ns = '.gaveg-slider-' + i;
		  $(window).on('resize' + ns, function () {
			clearTimeout(resizeTO);
			resizeTO = setTimeout(computeVisible, 120);
		  });
	
		  // Start
		  computeVisible();
		  startAutoplay();
		});
	
	  });
	})(jQuery);


  });
})(jQuery);

document.addEventListener('DOMContentLoaded', function () {
  function refreshSignatureInContainer(container) {
	if (!container) return;

	const signatureFields = container.querySelectorAll('[data-type="signature"][data-init-signature]');
	if (!signatureFields.length) return;

	signatureFields.forEach(function (field) {
	  const canvas = field.querySelector('canvas');
	  const input = field.querySelector('input[type="text"]');

	  if (!canvas || !input) return;

	  const wrapperWidth = Math.max(field.clientWidth, field.offsetWidth);
	  const height = parseInt(input.dataset.height, 10) || 76;

	  if (wrapperWidth > 0) {
		canvas.style.display = 'block';
		canvas.style.width = '100%';
		canvas.style.height = height + 'px';
		canvas.width = wrapperWidth;
		canvas.height = height;
	  }
	});

	window.dispatchEvent(new Event('resize'));

	setTimeout(function () {
	  window.dispatchEvent(new Event('resize'));
	}, 150);
  }

  document.querySelectorAll('.accordion .accordion-collapse').forEach(function (collapseEl) {
	collapseEl.addEventListener('shown.bs.collapse', function () {
	  refreshSignatureInContainer(collapseEl);
	});
  });

  document.querySelectorAll('.accordion .accordion-collapse.show').forEach(function (openEl) {
	setTimeout(function () {
	  refreshSignatureInContainer(openEl);
	}, 200);
  });
});